var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "content-card",
      on: {
        mouseover: function ($event) {
          _vm.hover = true
        },
        mouseleave: function ($event) {
          _vm.hover = false
        },
      },
    },
    [
      _c(
        _vm.attributeType,
        {
          tag: "component",
          staticClass: "content-card-image-region",
          class: _vm.attributeClass,
          attrs: {
            href: _vm.content.image.url,
            to: { path: _vm.content.image.url },
            target: _vm.targetNewWindow,
          },
        },
        [
          _c("standard-image-display", {
            staticClass: "image-layer image-layer-1",
            attrs: {
              alt: _vm.content.image.alt,
              title: _vm.content.image.title,
              source: _vm.content.image.fileStore.presignedURL,
              "object-position": _vm.content.image.objectPosition,
              "object-fit": _vm.content.image.objectFit,
              "lazy-loading": "lazy",
              "image-tint-strength": parseInt(_vm.content.image.tint),
              aspect: _vm.aspect,
            },
          }),
          _vm._v(" "),
          _vm.content.imageHover.fileStore.presignedURL
            ? [
                _c(
                  "transition",
                  { attrs: { name: "fade" } },
                  [
                    _c("standard-image-display", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.hover === true,
                          expression: "hover === true",
                        },
                      ],
                      staticClass: "image-layer image-layer-2",
                      attrs: {
                        alt: _vm.content.imageHover.alt,
                        title: _vm.content.imageHover.title,
                        source: _vm.content.imageHover.fileStore.presignedURL,
                        "object-position":
                          _vm.content.imageHover.objectPosition,
                        "object-fit": "cover",
                        "lazy-loading": "lazy",
                        "image-tint-strength": parseInt(
                          _vm.content.imageHover.tint
                        ),
                        aspect: _vm.aspect,
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("GridItemContent", { attrs: { content: _vm.content.text } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }